import React, { memo, forwardRef } from "react";
const SvgCapitalNu = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M20.112 23.152l-8.688-12.144h-.048v12.024c0 .496-.128.848-.384 1.056-.256.192-.52.288-.792.288-.288 0-.56-.096-.816-.288-.256-.208-.384-.56-.384-1.056V8.776c0-.656.16-1.112.48-1.368.32-.272.664-.408 1.032-.408.608 0 1.2.408 1.776 1.224l8.688 12.048h.048V8.344c0-.496.128-.84.384-1.032.256-.208.528-.312.816-.312.272 0 .536.104.792.312.256.192.384.536.384 1.032V22.6c0 .656-.16 1.12-.48 1.392-.32.256-.664.384-1.032.384-.608 0-1.2-.408-1.776-1.224z"
      />
    </svg>
  );
});
SvgCapitalNu.displayName = "SvgCapitalNu";
const MemoForwardRef = memo(SvgCapitalNu);
export default MemoForwardRef;
